import React, { useEffect } from "react";

import { Field } from "formik";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  Text,
  Divider,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Select,
} from "@chakra-ui/react";

import CustomDropzone from "../../../../../components/CustomDropzone";
import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";

const EstatutoEntidade = ({ formProps, mt }) => {
  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Flex
      flexDir="column"
      bgColor="#FFF"
      p="20px"
      borderRadius="16px"
      mt={mt ? mt : "20px"}
    >
      <Text
        color={"#169499"}
        fontWeight="700"
        fontSize="16px"
        lineHeight="21.6px"
        textTransform="uppercase"
      >
        Estatuto da Entidade
      </Text>
      <Divider orientation="horizontal" mt="10px" />
      <Grid
        templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(4, 1fr)" }}
        gap="20px"
        rowGap="15px"
        mt="20px"
      >
        <GridItem colSpan={2}>
          <Field name="possuiEstatuto">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.possuiEstatuto && form.touched.possuiEstatuto
                }
                id="possuiEstatuto"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="possuiEstatuto"
                >
                  Possui Estatuto da Entidade?*
                </FormLabel>
                <Select
                  {...field}
                  h="42px"
                  name="possuiEstatuto"
                  id="possuiEstatuto"
                  placeholder="Selecione"
                  backgroundColor="white"
                >
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </Select>
                <FormErrorMessage>
                  {form.errors.possuiEstatuto}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        {formProps.values.possuiEstatuto === "S" && (
          <>
            <GridItem colSpan={1} rowSpan={{ base: 1, lg: 3 }}>
              <Flex>
                <CustomDropzone
                  title="Anexar Estatuto da Entidade*"
                  fieldName="anexoEstatuto"
                  height="auto"
                  formProps={formProps}
                />
              </Flex>
            </GridItem>
            <GridItem colSpan={1} />
            <GridItem colSpan={{ base: 1, md: 1, lg: 2 }}>
              <CustomDatepickerWField
                fieldName="ultimaAtualizacaoEstatuto"
                label="Última atualização do Estatuto da Entidade*"
                placeholder="DD/MM/AAAA"
              />
            </GridItem>
          </>
        )}
      </Grid>
    </Flex>
  );
};

export default EstatutoEntidade;
